module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter00"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/lom.htm"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("1. The German invasion of Poland, September 1939")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("2. Poland defeated, October 1939")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("3. Finland defiant, November 1939")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("4. The Scandinavian cockpit, winter 1939–1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("5. The German attack in the West, May 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("6. Dunkirk, May 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("7. The battle for France, June 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("8. France’s agony, Britain’s resolve, June–July 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("9. The battle for Britain, August–September 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("10. ‘The war is won!’ (Hitler), October 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("11. The ‘new order of tyranny’ (Roosevelt), winter 1940–1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("12. The widening war, January–March 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("13. The German conquest of Yugoslavia and Greece, April 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("14. The fall of Crete; war in Africa, April–May 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("15. The German invasion of Russia, June 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("16. Terror in the East, July–August 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("17. Towards Leningrad, Moscow and Kiev, September 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_vm._v("18. Russia at bay, September–October 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_vm._v("19. ‘Deciding the fate of Europe’ (Hitler), November 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c20.htm"
    }
  }, [_vm._v("20. The limits of German conquest, December 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21.htm"
    }
  }, [_vm._v("21. Japan strikes, December 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c22.htm"
    }
  }, [_vm._v("22. ‘We are no longer alone’ (Churchill), New Year 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c23.htm"
    }
  }, [_vm._v("23. Global war, February–April 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c24.htm"
    }
  }, [_vm._v("24. The spread of resistance and terror, summer 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c25.htm"
    }
  }, [_vm._v("25. Axis triumphs, July 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c26.htm"
    }
  }, [_vm._v("26. Guadalcanal, Dieppe, El Alamein, August–September 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c27.htm"
    }
  }, [_vm._v("27. Stalingrad and ‘Torch’, September–October 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c28.htm"
    }
  }, [_vm._v("28. The turn of the tide for the Allies, winter 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c29.htm"
    }
  }, [_vm._v("29. Casablanca: blueprint for victory, January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c30.htm"
    }
  }, [_vm._v("30. The German armies in danger, February 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c31.htm"
    }
  }, [_vm._v("31. ‘Drive the enemy into the sea’ (Montgomery), spring 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c32.htm"
    }
  }, [_vm._v("32. ‘The first crack in the Axis’ (Roosevelt), summer 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c33.htm"
    }
  }, [_vm._v("33. Germany and Japan in retreat, autumn 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c34.htm"
    }
  }, [_vm._v("34. ‘Bleeding to death in the East’ (Goebbels), winter 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c35.htm"
    }
  }, [_vm._v("35. Anzio, Cassino, Kwajalein, January–February 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c36.htm"
    }
  }, [_vm._v("36. Bombing, deportation, and mass murder, February–March 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c37.htm"
    }
  }, [_vm._v("37. Resistance, sabotage and deception, spring 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c38.htm"
    }
  }, [_vm._v("38. D-Day, June 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c39.htm"
    }
  }, [_vm._v("39. Germany encircled, July 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c40.htm"
    }
  }, [_vm._v("40. The battles for Poland and France, summer 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c41.htm"
    }
  }, [_vm._v("41. The bitter-sweet path of liberation, autumn 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c42.htm"
    }
  }, [_vm._v("42. Into Germany; towards the Philippines, September 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c43.htm"
    }
  }, [_vm._v("43. Fighting for every mile, October–November 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c44.htm"
    }
  }, [_vm._v("44. Flying bombs, suicide pilots, death marches, January 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c45.htm"
    }
  }, [_vm._v("45. Berlin, Manila, Dresden, Tokyo, February–March 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c46.htm"
    }
  }, [_vm._v("46. The Axis in disarray; the Allies in conflict, March–April 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c47.htm"
    }
  }, [_vm._v("47. The deaths of Roosevelt, Mussolini and Hitler, April 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c48.htm"
    }
  }, [_vm._v("48. The end of the war in Europe, May 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c49.htm"
    }
  }, [_vm._v("49. Germany in defeat, Japan unbowed, May–July 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c50.htm"
    }
  }, [_vm._v("50. Alamogordo, Potsdam, Hiroshima, July–August 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c51.htm"
    }
  }, [_vm._v("51. The defeat of Japan, August 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c52.htm"
    }
  }, [_vm._v("52. Retribution and Remembrance, 1945–1952")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c53.htm"
    }
  }, [_vm._v("53. ‘Unfinished business’, 1953–1989")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/b01.htm"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/b02.htm"
    }
  }, [_vm._v("Regional Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 69
// module chunks = 0